import React from "react";
import { Box } from "@mui/material";
import NotFoundPageComponent from "../../components/error-pages/4xx";

function NotFoundPage() {
  return <Box>{<NotFoundPageComponent />}</Box>;
}

export default NotFoundPage;
